/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
const {ccclass, property} = cc._decorator;

/**
 * Data serialized class which contains a node and an animation name.
 */
@ccclass("NodeAnimationData")
export default class NodeAnimationData
{
    @property({ type: cc.Node })
    public Node: cc.Node = null;

    @property()
    public AnimationName: string = "";
}
